import React, { useEffect, useMemo, useState } from 'react';
import styles from '../../styles.module.css';
import Checkbox from '@/components/common/CheckBox';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import Api from '@/api';
import { categoryType } from '@/commonTypes';
import { useLayoutContext } from '@/context/LayoutContext';

export default function CategoryFilters({
  list,
  queryKey = 'category',
}: {
  list?: categoryType[];
  queryKey: string;
}) {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();
  const { setActiveCategories, activeCategories } = useLayoutContext();

  console.log('queryKey==', queryKey);
  // const sample = {
  //   id: 1,
  //   title: '',
  //   count: 2,
  //   slug: 'category1',
  // };
  // const list = Array.from({ length: 4 }, (_, index) => ({
  //   ...sample,
  //   id: index + 1,
  //   slug: 'category' + index,
  //   title: 'title' + index,
  //   count: index + 1,
  // }));

  const chooseCategory = (item: categoryType) => {
    const params = new URLSearchParams(searchParams.toString());

    const categories = params?.get(queryKey)?.split(',').filter(Boolean) || [];

    if (categories.includes(item.slug)) {
      const updated = categories?.filter((slug) => slug !== item.slug);

      if (updated.length > 0) {
        params.set(queryKey, updated.join(','));
        // setActiveCategories([...activeCategories, item]);
      } else {
        params.delete(queryKey);
        // setActiveCategories(activeCategories?.filter((x: categoryType) => x.id != item?.id));
      }
      params.set('page', '1');
    } else {
      params.set('page', '1');
      categories.push(item.slug);

      params.set(queryKey, categories.join(','));
    }

    router.push(`${pathname}${params.toString() ? `?${params.toString()}` : ''}`);
  };

  console.log('activeCategories====', activeCategories);
  // const selectedCategories = searchParams.get('category')?.split(',') || [];
  const selectedCategories = useMemo(
    () => searchParams.get(queryKey)?.split(',') ?? [],
    [searchParams.get(queryKey)],
  );

  useEffect(() => {
    setActiveCategories(list?.filter((item) => selectedCategories.includes(item.slug)) ?? []);
  }, [list, selectedCategories]);

  console.log('queryKey====', queryKey);
  return (
    <div className={`${styles.filter_list}`}>
      {list?.map((item: categoryType, index: number) => (
        <div key={index} className={`${styles.singleCategory}`}>
          <Checkbox
            title={item?.title}
            checked={selectedCategories.includes(item?.slug)}
            onChange={() => {
              chooseCategory(item);
            }}
            titleClass={`${styles.Check_label}`}
          />
          <span className={`${styles.check_n} mono}`}>{item?.productCount}</span>
        </div>
      ))}
    </div>
  );
}
